import React from 'react';
import {useHistory} from 'react-router-dom';
import styled from 'styled-components';
import {MailThread, AutomaticMailSendMailThread} from 'api';
import Messages from './Messages';

interface AutomaticMailSend extends MailThread {
  threadable: AutomaticMailSendMailThread;
}

interface Props {
  mailThread: AutomaticMailSend;
}

export default ({mailThread}: Props) => {
  const history = useHistory();
  const {
    threadable: {automaticMailSend},
    mailMessages,
  } = mailThread;

  return (
    <Container>
      <a onClick={history.goBack}>&lt; 戻る</a>
      <h2>{automaticMailSend.subject}</h2>
      <Messages mailMessages={mailMessages} />
    </Container>
  );
};

const Container = styled.div`
  h2 {
    font-weight: 500;
    font-size: 16px;
    margin-top: 1rem;
  }
`;
